var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3730",
    "data-name": "Rectangle 3730",
    width: 31,
    height: 28,
    transform: "translate(0.093 0)",
    fill: "#ccc",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_247",
    "data-name": "Mask Group 247",
    transform: "translate(-0.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_789_",
    transform: "translate(3.214 -0.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_790_",
    d: "M25.44,27.585a1.284,1.284,0,0,0,1.312-1.254V1.254A1.255,1.255,0,0,0,25.942.1a1.357,1.357,0,0,0-1.43.272l-2.784,2.66L18.945.367a1.356,1.356,0,0,0-1.856,0l-2.784,2.66L11.522.367a1.356,1.356,0,0,0-1.856,0L6.883,3.027,4.1.367A1.357,1.357,0,0,0,2.669.1a1.255,1.255,0,0,0-.81,1.158V26.331a1.284,1.284,0,0,0,1.312,1.254Zm-6.906-11.96a2.291,2.291,0,0,1,1.446.424,1.709,1.709,0,0,1,.624,1.422v2.015c0,1.173-.755,1.846-2.07,1.846s-2.071-.673-2.071-1.846V17.471C16.464,16.315,17.238,15.625,18.534,15.625Zm-2.164-4.85a.637.637,0,0,1,.593-.348.728.728,0,0,1,.738.693.677.677,0,0,1-.078.321l-5.261,9.828a.712.712,0,0,1-.644.381h0a.7.7,0,0,1-.711-.666.665.665,0,0,1,.078-.308Zm-8.363,2c0-1.173.754-1.846,2.07-1.846s2.071.673,2.071,1.846v2.015c0,1.173-.755,1.846-2.071,1.846s-2.07-.673-2.07-1.846Z",
    transform: "translate(-1.859 0)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_795_",
    d: "M17.5,19.708c.6,0,.677-.293.677-.58V17.113c0-.287-.08-.581-.676-.581a.815.815,0,0,0-.51.137.564.564,0,0,0-.153.444v2.016a.563.563,0,0,0,.152.443A.816.816,0,0,0,17.5,19.708Z",
    transform: "translate(-0.823 0.358)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_796_",
    d: "M9.588,15.114c.6,0,.677-.294.677-.581V12.519c0-.287-.081-.581-.677-.581s-.663.279-.663.581v2.015C8.925,14.835,9.005,15.114,9.588,15.114Z",
    transform: "translate(-1.37 0.259)",
    fill: "#ccc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentIcon);
export default __webpack_public_path__ + "static/media/percentIcon.f1fcac3357b1cd8ab7e762cdd6d58d85.svg";
export { ForwardRef as ReactComponent };